'use strict';

import { AuthenticationRequest } from './AuthenticationRequest';

interface MfaReply {
    message : string;
    screen : string;
    response : 'VALIDATE' | 'RESEND';
    code : string;
}

class LoginRequest extends AuthenticationRequest{
    private password : any;
    private username : string;
    private token : string;
    private mfaReply : MfaReply;

    constructor(user, pass, token){
        super('login', 'POST');
        this.setUserName(user);
        this.setPassword(pass);
        this.token = token;
    }

    setUserName(username){
        this.username = username;
    }

    setPassword(pass){
        this.password = pass;
    }

    setMfaReply(mfaReply : MfaReply){
        this.mfaReply = mfaReply;
    }

    getHeaders(){
        let headers : { [k: string]: string } = {
            'X-Auth-User': this.username,
            'X-Auth-Pass': this.password
        };
        if (this.mfaReply) {
            headers['X-Auth-Mfa-Message'] = this.mfaReply.message;
            headers['X-Auth-Mfa-Screen'] = this.mfaReply.screen;
            headers['X-Auth-Mfa-Response'] = this.mfaReply.response;
            headers['X-Auth-Mfa-Code'] = this.mfaReply.code;
        }
        return headers;
    }

    getSerializable(){
        return {};
    }

    getName(){
        return 'LoginRequest';
    }

    getUrl() {
        if (!this.token) {
            return super.getUrl();
        } else {
            let url = this.token;
            url += '/' + this.controller;
            url += '/' + this.service;

            return url;
        }
    }
}

export { LoginRequest, MfaReply };